module.exports = __webpack_public_path__ + "static/logo-vertical-light-300x246-21b6f2b9020103f4d9ac97ab89e03bb9.png";